<template lang="html">
  <d-row>
    <!-- Editor -->
    <d-col class="mb-4">
      <d-card class="card-small">

        <!-- Form Example -->
        <d-card-header class="page-header border-bottom">
          <h3 class="page-title m-0">{{ (model.rating) ? model.rating.name : '' }}</h3>
        </d-card-header>

        <d-list-group flush class="list_questions">
          <d-list-group-item class="pb-0" v-for="(row, index) in model.answers" :key="index">
            <h5 class="mb-2">{{ row.question }}</h5>
            <p class="mb-3 d-flex align-items-center" v-if="row.type == 'int'">R: <input-star :model="parseFloat(row.value)" :increment='0.5' :read-only='true' class="ml-2"/></p>
            <p class="mb-3" v-else>R: {{ row.value }}</p>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import Events from '_utils/events';
import InputStar from '_shared/InputStar.vue';
import { _LOAD_MODEL_ } from './RatingModel';

export default {
  name: 'rating-user-answer',
  components: {
    InputStar,
  },
  data() {
    return {
      model: {},
    };
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, questions => {
      this.model = questions;
    });
  },
};
</script>

<style lang="scss" scoped>
.list_questions {
  h5 {
    font-size: 1.16rem;
    font-weight: bold;
  }
  p {
    font-size: 1rem;
  }
}
</style>
